import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeIntervention } from 'src/api/models';

@Component({
  selector: 'app-intervention-type-select',
  templateUrl: './intervention-type-select.component.html',
  styleUrls: ['./intervention-type-select.component.css']
})
export class InterventionTypeSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input('width') width: number;

  @Input() cell: any;

  interventionsTypes = [];

  constructor(private translateService: TranslateService) { 
    for (var t in TypeIntervention) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.interventionsTypes.push({ id: value, name: this.translateService.instant('Entretien.Interventions.Types.' + TypeIntervention[t])});
      }
    } 
  }

  ngOnInit(): void {    
  }


  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }  
}
